const SGR = ({ ...props }) => (
  <svg
    version="1.1"
    viewBox="0 0 2048 2048"
    width="1280"
    height="1280"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      transform="translate(996,4)"
      d="m0 0h63l49 3 49 5 41 6 50 10 48 12 40 12 41 14 38 15 32 14 34 16 27 14 24 14 21 12 22 14 27 18 14 10 17 12 18 14 15 12 14 11 11 10 11 9 15 14 13 12 42 42 7 8 12 13 9 11 9 10 9 11 11 14 12 15 13 18 12 17 11 16 11 17 12 19 13 22 16 29 17 33 15 32 13 31 14 37 16 47 12 43 10 42 8 42 7 49 5 49 2 22v97l-5 57-6 48-6 37-9 43-11 43-12 39-14 41-16 40-11 25-16 34-12 23-13 24-14 24-14 23-10 15-13 19-12 17-12 16-10 13-11 14-9 11-12 14-10 11-9 11-11 11-7 8-36 36-8 7-7 7-8 7-28 24-16 13-26 20-17 12-18 13-26 17-21 13-26 15-29 16-44 22-39 17-36 14-34 12-32 10-37 10-39 9-36 7-46 7-47 6h-163l-70-9-41-7-51-11-44-12-35-11-37-13-42-17-33-15-29-14-32-17-24-14-18-11-20-13-21-14-17-12-19-14-28-22-11-9-14-12-10-9-11-9-17-17-8-7-27-27-7-8-10-10-9-11-11-12-9-11-11-13-10-13-11-14-26-36-10-15-14-22-13-21-16-28-13-24-16-32-14-31-17-42-15-42-10-32-12-44-9-40-7-38-5-35-4-36-3-37-1-25v-64l2-41 5-52 6-42 7-37 8-37 12-45 15-47 16-43 13-31 15-33 19-38 11-19 6-11 14-24 11-17 16-25 13-18 10-14 13-17 22-28 9-10 9-11 11-12 7-8 15-16 10-10 6-7 8-7 16-16 8-7 14-13 11-9 11-10 14-11 15-12 20-15 18-13 20-14 19-12 17-11 22-13 25-14 23-12 15-8 28-13 35-15 34-13 47-16 42-12 37-9 40-8 43-7 44-5 42-3z"
      fill="#8E26A4"
    />
    <path
      transform="translate(571,936)"
      d="m0 0 45 3 58 3 117 5 127 3h251l54-2 67-2 88-4 52-3 31-2 17-1 2 7 1 11v29l-4 27-6 27-11 45-5 25-2 18v40l7 76 2 39v69l-2 37-4 41-5 36v19l4 11 8 11 10 7 11 4 15 2 13 5 10 9 5 9 1 4v15l-4 10-9 10-6 4-6 2-7 1h-944l-10-3-11-7-7-10-3-9v-12l4-11 9-10 8-5 13-3 14-2 14-7 7-7 6-10 3-9v-14l-6-43-4-44-2-35v-64l3-48 6-65 1-16v-16l-2-25-5-27-15-62-5-27-2-17v-19l2-17z"
      fill="#FEFFFE"
    />
    <path
      transform="translate(581,757)"
      d="m0 0h22l28 2 77 4 100 4 85 2 80 1h168l105-3 118-5 85-5h11l15 2 16 6 14 9 10 9 9 12 7 14 4 14 1 7v13l-3 16-7 16-9 12-7 7-15 10-13 5-17 3-64 4-79 4-103 4-36 1-64 1h-214l-44-1-111-4-85-4-69-4-17-2-17-5-13-7-10-8-7-7-7-10-6-12-4-13-1-5v-21l4-16 7-14 9-11 9-9 11-7 11-5z"
      fill="#FEFFFE"
    />
    <path
      transform="translate(1009,468)"
      d="m0 0h30l24 4 21 7 16 8 13 8 14 11 7 7 2 1v2l4 2 24 24v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2v2l4 2 7 8 29 29v2l-33 2-77 3-93 3-61 1h-142l-54-1-127-4-71-3-5-1 6-7 225-225 13-10 13-8 16-8 21-7z"
      fill="#FEFFFE"
    />
    <path
      transform="translate(1320,1177)"
      d="m0 0h14l16 1 9 3 8 5 7 8 4 9 1 5v36l-4 12-6 8-9 7-9 3-8 1-21 1 13 11 10 8 10 9 11 9 8 7 5 8-1 7-6 7-2 1h-8l-11-8-10-9-11-9-10-9-11-9-9-8-1 40-3 8-6 4h-8l-7-5-2-5v-126l3-10 7-9 9-7 10-3z"
      fill="#8E26A4"
    />
    <path
      transform="translate(1168,1178)"
      d="m0 0h14l13 3 13 7 10 10 6 10 4 13v112l-4 7-5 3h-7l-6-4-3-5-1-59h-54v57l-4 8-5 3h-7l-6-4-3-4-1-6v-100l2-14 4-10 8-11 10-8 13-6z"
      fill="#8E26A4"
    />
    <path
      transform="translate(1008,1178)"
      d="m0 0h69l6 4 3 6-1 7-6 7-2 1-63 1-8 2-5 5-2 4-1 6v78l2 9 3 5 5 3 4 1h33l7-2 6-7 2-8v-8l-2-9-5-6-16-6-5-5-1-8 5-8 4-2h11l11 4 9 6 8 9 5 11 2 7v20l-3 11-6 11-8 8-9 5-9 3-7 1h-32l-12-3-10-5-10-10-5-9-3-12v-89l3-12 6-10 4-5 10-7z"
      fill="#8E26A4"
    />
    <path
      transform="translate(833,1175)"
      d="m0 0 8 2 4 5 2 5 1 111 3 8 4 5 7 4 10 2 10-1 10-4 6-7 2-4 1-6v-108l3-6 6-5 5-1 6 2 5 6 1 3v115l-4 13-7 11-9 8-10 6-13 4h-19l-13-4-12-7-9-9-6-10-3-10-1-9v-108l3-5 6-5z"
      fill="#8E26A4"
    />
    <path
      transform="translate(720,1175)"
      d="m0 0h33l14 1 6 4 3 4v9l-5 6-6 2-51 1-7 3-6 5-3 6-1 5v7l4 10 5 5 6 3 6 1 18 1 13 4 10 6 7 7 6 10 4 12v17l-4 12-7 11-9 8-12 6-7 2-16 1h-36l-7-2-6-7v-9l6-7 3-1 47-1 10-2 6-4 4-5 2-7v-9l-4-8-6-5-8-3-18-1-10-2-9-4-8-6-7-7-7-14-2-8v-14l3-12 5-10 9-10 12-7 10-3z"
      fill="#8E26A4"
    />
    <path
      transform="translate(1313,1203)"
      d="m0 0h24l11 1 4 3 2 13v17l-2 8-3 3-4 1h-44l-2-1v-39l4-5z"
      fill="#FEFFFE"
    />
    <path
      transform="translate(1173,1203)"
      d="m0 0 11 1 8 4 7 7 3 6 1 7v21l-1 1h-52l-2-1v-26l4-8 8-8 7-3z"
      fill="#FEFFFE"
    />
  </svg>
);
export default SGR;
